// A multi-file download is streamed as one zip through the backend, which
// Cloud Run cuts off after its request timeout (3600 s is the platform
// maximum). The server streams at ~70 MB/s (dev, 2026-10-04), so the real
// limit is the user's own connection: about 3 MB/s finishes 10 GB inside the
// hour. Nothing is refused above this size — the page just says so up front.
export const LARGE_BUNDLE_MB = 10 * 1024;

export const LARGE_BUNDLE_NOTE =
  'Large bundle: on a slow connection it may take over an hour and stop early. If that happens, download in smaller batches.';

export const isLargeBundle = (totalMb) => Number(totalMb) > LARGE_BUNDLE_MB;
